import React, {Component} from 'react'
import {Nav, NavLink, NavItem, TabContent, TabPane, Row, Col} from 'reactstrap'
import {Query} from 'react-apollo'
import classnames from 'classnames'
import {ToastContainer} from 'react-toastify'

import ClientSummary from "./ClientSummary";

import clientQuery from '../../../queries/server/client'
import Loading from "../Loading";
import ClientDetailForm from "./ClientDetailForm";
import ClientProjectsList from "./ClientProjectsList";
import ClientCommunicationMethods from "./ClientCommunicationMethods";
import ClientLocations from "./ClientLocations";
import ClientContacts from "./ClientContacts";
import {checkPermission, CLIENT_PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY} from "../../../lib/permissions";


class Client extends Component {

    state = {
        activeTab: 'details'
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {

        const {client_id} = this.props.match.params

        return (
            <Query query={clientQuery} variables={{client_id}}>
                {({data, loading, error}) => {

                    console.log('client', data)

                    if (loading) return <Loading/>

                    return (
                        <div className="m-4">
                            <ClientSummary
                                className="mb-4"
                                client={data.client}
                            />

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'details'})}
                                        onClick={() => {
                                            this.toggle('details');
                                        }}
                                    >
                                        Details
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'communication_methods'})}
                                        onClick={() => {
                                            this.toggle('communication_methods');
                                        }}
                                    >
                                        Communication Methods
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'contacts'})}
                                        onClick={() => {
                                            this.toggle('contacts');
                                        }}
                                    >
                                        Contacts
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'addresses'})}
                                        onClick={() => {
                                            this.toggle('addresses');
                                        }}
                                    >
                                        Addresses
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'projects'})}
                                        onClick={() => {
                                            this.toggle('projects');
                                        }}
                                    >
                                        Projects
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="details">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <ClientDetailForm client={data.client}/>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="communication_methods">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <ClientCommunicationMethods
                                                client_id={data.client.client_id}
                                                communicationMethods={data.client.client_communication_methods}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="contacts">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <ClientContacts
                                                client_id={data.client.client_id}
                                                contacts={data.client.contacts}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="addresses">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <ClientLocations client_id={data.client.client_id}
                                                             addresses={data.client.addresses}/>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="projects">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <ClientProjectsList
                                                projects={data.client.projects}
                                                canViewFinancialSummary={checkPermission(CLIENT_PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY)}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                            <ToastContainer/>
                        </div>
                    )
                }}

            </Query>
        )
    }

}

export default Client